import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface ITenure {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  ownedOutright?: number | null;
  ownedMortgageLoan?: number | null;
  sharedOwnership?: number | null;
  socialRentedCouncil?: number | null;
  socialRentedOther?: number | null;
  privateRented?: number | null;
  livesRentFree?: number | null;
}

export const defaultValue: Readonly<ITenure> = {};
